// src/components/BottomNav.jsx
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from './Icon';

// items: [{ path, label, match: (pathname) => bool, iconName: string }]
export default function BottomNav({ items }) {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav className="bottom-nav">
      {items.map(item => (
        <button
          key={item.path}
          className={`nav-item ${item.match(location.pathname) ? 'active' : ''}`}
          onClick={() => navigate(item.path)}
        >
          <Icon name={item.iconName} size={22} stroke={1.75} />
          {item.label}
        </button>
      ))}
    </nav>
  );
}
